export enum GameType {
  WEAVER = 'weaver',
  WEAVER_X = 'weaver-x',
  SUBTEXT = 'subtext'
}